<template>
<div class="card">
    <div class="card-header">PPL Leave and Payroll Details</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>

      <b-form @submit.stop.prevent="onPayrollSubmit">
        <!--        name, employeeID, division, department-->
        <b-row>
          <b-col cols="12" lg="3">
            <BaseTextOutput label="Employee Name" :value="request.employee.name"/>
          </b-col>
          <b-col cols="12" lg="3">
            <BaseTextOutput label="Employee ID" :value="request.employee.employeeId"/>
          </b-col>
          <b-col cols="12" lg="3">
            <BaseTextOutput label="Division" :value="request.division"/>
          </b-col>
          <b-col cols="12" lg="3">
            <BaseTextOutput label="Department ID" :value="request.departmentId"/>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" lg="3">
            <BaseTextOutput label="Effective Start Date"
                            :value="request.effectiveStartDate"/>
          </b-col>
          <b-col cols="12" lg="3">
            <BaseTextOutput label="Effective End Date"
                            :value="request.effectiveEndDate"/>
          </b-col>
          <b-col cols="12" lg="3">
            <BaseTextOutput label="Leave Hours"
                            :value="request.leaveHours"/>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-table hover small show-empty
                     responsive="true"
                     :fields="leaveCommentFields"
                     :items="request.leaveComments"
                     :busy="false">
              <template v-slot:no-data>
                No Leave or Request Returned Comments Found.
              </template>
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
              <template slot="empty" slot-scope="scope">
                No Leave or Request Returned Comments Found.
              </template>
            </b-table>
          </b-col>
        </b-row>

        <div v-if="request.payrollActionsString && request.payrollActionsString.includes('PPL')">
          <b-button type="button" variant="primary" @click="onPayrollSubmit">Complete</b-button>
          <b-button type="button" variant="outline-primary" @click="save">Save</b-button>
          <b-button type="button" variant="outline-danger" v-b-modal.modal-return-previous-lifecycle>Return to Leave
            Specialist
          </b-button>
        </div>
      </b-form>
    </div>
  <b-modal id="modal-return-previous-lifecycle" hide-header hide-footer @hidden="close">
    <h2>Return To Previous Lifecycle</h2>
    <hr/>
    <form ref="form" @submit.prevent="onReturnToPriorLifecycle()">
      <BaseParagraphInput v-model="returnPreviousLifecycleComments"
                          :v="$v.returnPreviousLifecycleComments"
                          slug="returnPreviousLifecycleComments"
                          :required="$v.returnPreviousLifecycleComments.$params.required ? true : false"
                          label="Reason for returning to the previous lifecycle"/>
      <b-button @click="close" style="margin-right:15px;">Cancel</b-button>
      <b-button type="submit" variant="primary" :disabled="$v.returnPreviousLifecycleComments.$invalid">Submit</b-button>
    </form>
  </b-modal>
</div>

</template>

<script>
import axios from "axios"
import { commonOptions } from '@/mixins/commonOptions.js'
import { tableFields } from '@/mixins/tableFields.js'
import BaseTextOutput from "@/components/BaseTextOutput";
import {  required,  maxLength, } from 'vuelidate/lib/validators'



export default {
  components: {
    BaseTextOutput,
  },
  mixins: [
    commonOptions,
    tableFields
  ],
  props: {
    request: Object
  },
  data() {
    return {
      checklistComplete: false,
      saveOnly: false,
      returnPreviousLifecycleComments: null,
    }
  },
  validations() {
    return {
      returnPreviousLifecycleComments: {required: false, maxLength: maxLength(4000)},
    }
  },
  computed: {
  },
  created() {
  },

  methods: {
    updateChecklistStatus(b) {
      this.checklistComplete = b
    },

    save() {
      this.saveOnly = true
      this.onPayrollSubmit()
      this.saveOnly = false
    },

    onPayrollSubmit() {
      if (!this.saveOnly) {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$nextTick(() => {
            document.getElementById('form-container').scrollIntoView()
          })
          return
        }
      }

      let payload = {
        requestId: this.request.id,
        requestStatus: '30',
        payrollAction: 'PPL',
        saveOnly: this.saveOnly
      }

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/payroll/complete`, payload)
          .then(response => {
            if(this.saveOnly === false){
              this.showRootToast("Payroll PPL Leave Completed", "Success", "success")
            }
            else{
              this.showRootToast("HRM Request Has Been Saved", "Success", "success")
            }
            this.$router.push('/home')
          })

    },

    close() {
      this.$bvModal.hide("modal-return-previous-lifecycle")
      this.returnPreviousLifecycleComments=null
    },
    onReturnToPriorLifecycle(){
      console.log("We are returning this request")
      let payload = {
        id: this.request.id,
        comment: this.returnPreviousLifecycleComments
      }

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/payroll/leave/return`, payload)
          .then(response => {
            this.showRootToast("HRM Request Has Been Sent Back To Transactions Specialist", "Success", "success")
            this.$router.push('/home')
          })
    },

    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true
      })

    },
  }
}
</script>